import type { Embodiment } from "@/api";

// formatEndEffector 의 원본은 공용 모듈이다. 표시 규칙(EE `name:tag`)을 한 곳에서 관리한다.
export { formatEndEffector } from "@/components/embodiment/embodimentDisplay";

// 검색어 유무에 따른 빈 목록 안내.
export function formatEmptyEmbodimentMessage({
  hasSearchQuery,
  searchQuery,
}: {
  hasSearchQuery: boolean;
  searchQuery: string;
}): string {
  if (hasSearchQuery) {
    return `검색어 "${searchQuery}"와 일치하는 Embodiment가 없습니다. 검색어를 바꿔 보세요.`;
  }
  return "아직 등록된 Embodiment가 없습니다. 새 Embodiment를 추가해 주세요.";
}

// embodiment 표시 이름. name 이 유일 식별자다.
export function formatEmbodimentTitle(embodiment: Pick<Embodiment, "name">): string {
  return embodiment.name;
}
